export enum OnboardingStatus {
  completed = 1,
  uncompleted = 0,
}
